// extracted by mini-css-extract-plugin
export var lg = "_kr-7";
export var md = "_kr-6";
export var placeholderContainer = "_kr-1";
export var placeholderIcon = "_kr-2";
export var productImage = "_kr-0";
export var sm = "_kr-5";
export var xl = "_kr-8";
export var xs = "_kr-4";
export var xxs = "_kr-3";